"use client";

import React, { useState, useEffect } from "react";

interface Beam {
  left: number;
  top: number;
  height: number;
  opacity: number;
  rotation: number;
  duration: number;
}

export const BackgroundBeams = () => {
  const [beams, setBeams] = useState<Beam[]>([]);

  useEffect(() => {
    const generatedBeams: Beam[] = Array.from({ length: 6 }, () => ({
      left: Math.random() * 100,
      top: Math.random() * 100,
      height: Math.random() * 200 + 100,
      opacity: Math.random() * 0.5 + 0.2,
      rotation: Math.random() * 360,
      duration: 3 + Math.random() * 2,
    }));
    setBeams(generatedBeams);
  }, []);

  return (
    <div className="absolute inset-0 -z-10 h-full w-full overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-slate-950 via-blue-950 to-indigo-950" />
      <div className="absolute inset-0">
        {beams.map((beam, i) => (
          <div
            key={i}
            className="animate-pulse"
            style={{
              position: "absolute",
              left: `${beam.left}%`,
              top: `${beam.top}%`,
              width: "2px",
              height: `${beam.height}px`,
              background: `linear-gradient(180deg, transparent, rgba(59, 130, 246, ${beam.opacity}), transparent)`,
              transform: `rotate(${beam.rotation}deg)`,
              animationDelay: `${i * 0.5}s`,
              animationDuration: `${beam.duration}s`,
            }}
          />
        ))}
      </div>
    </div>
  );
};
